/* eslint-disable */
import { useEffect, useState } from 'react';
import {
	Dialog,
	DialogTitle,
	DialogContent,
	IconButton,
	Table,
	TableHead,
	TableRow,
	TableCell,
	TableBody,
} from '@mui/material';
import { X } from 'lucide-react';
import moment from 'moment';
import myMachineService from '../../../Services/AssetServices/myMachine.service';
import { notificationServices } from '../../../Services';
import { BackdropLoader } from '../../../Components/Loaders';

const PAGE_SIZE = 50;

const formatTs = (ts) =>
	ts ? moment.unix(ts).format('YYYY-MM-DD HH:mm:ss') : '-';

const pct = (value) =>
	value === null || value === undefined ? '-' : `${Math.round(value)}%`;

const networkText = (network) => {
	if (network?.connected === false) {
		return 'Disconnected';
	}
	if (network?.latencyMs !== null && network?.latencyMs !== undefined) {
		return `${Math.round(network.latencyMs)}ms`;
	}
	return '-';
};

// MachineHealthLog change-log viewer for a single machine.
function MachineHealthLogsModal({ open, machine, onClose }) {
	const [isLoading, setIsLoading] = useState(false);
	const [logs, setLogs] = useState([]);

	useEffect(() => {
		if (!open || !machine?.id) {
			return;
		}
		(async () => {
			setIsLoading(true);
			setLogs([]);
			try {
				const response = await myMachineService.fetchMachineHealthLogs({
					req: {
						data: {
							machineId: machine.id,
							page: 1,
							pageSize: PAGE_SIZE,
						},
					},
				});
				if (response?.statusCode === 200) {
					setLogs(response?.data || []);
				} else {
					notificationServices.generateNotification({
						type: 'error',
						message: response?.message || 'Failed to load health logs',
					});
				}
			} catch (error) {
				notificationServices.generateNotification({
					type: 'error',
					message: 'Failed to load health logs',
				});
			} finally {
				setIsLoading(false);
			}
		})();
	}, [open, machine?.id]);

	return (
		<Dialog open={open} onClose={onClose} maxWidth='lg' fullWidth>
			<DialogTitle className='flex items-center justify-between'>
				<span>
					Health Logs
					{machine?.machine_name ? ` — ${machine.machine_name}` : ''}
				</span>
				<IconButton onClick={onClose} size='small'>
					<X className='size-4' />
				</IconButton>
			</DialogTitle>
			<DialogContent dividers style={{ position: 'relative', minHeight: '8rem' }}>
				<BackdropLoader showProgress isLoading={isLoading} />
				{!isLoading && logs.length === 0 ? (
					<div className='py-8 text-center text-gray-500'>
						No health logs found for this machine.
					</div>
				) : (
					<Table size='small' stickyHeader>
						<TableHead>
							<TableRow>
								<TableCell>Time</TableCell>
								<TableCell>Change Reason</TableCell>
								<TableCell>Mode</TableCell>
								<TableCell>CPU</TableCell>
								<TableCell>RAM</TableCell>
								<TableCell>Disk</TableCell>
								<TableCell>Network</TableCell>
							</TableRow>
						</TableHead>
						<TableBody>
							{logs.map((log) => {
								return (
									<TableRow key={log.id}>
										<TableCell>{formatTs(log.machineTs)}</TableCell>
										<TableCell style={{ whiteSpace: 'pre-wrap' }}>
											{log.changeReason || '-'}
										</TableCell>
										<TableCell>{log.currentMode || '-'}</TableCell>
										<TableCell>
											{pct(log?.cpu?.usedPct)}
											{log?.cpu?.temp?.currentC !== null &&
											log?.cpu?.temp?.currentC !== undefined
												? ` / ${Math.round(log.cpu.temp.currentC)}°C`
												: ''}
										</TableCell>
										<TableCell>{pct(log?.ram?.usedPct)}</TableCell>
										<TableCell>{pct(log?.disk?.usedPct)}</TableCell>
										<TableCell>{networkText(log?.network)}</TableCell>
									</TableRow>
								);
							})}
						</TableBody>
					</Table>
				)}
				{!isLoading && logs.length >= PAGE_SIZE && (
					<div className='py-2 text-center text-xs text-gray-400'>
						Showing the latest {PAGE_SIZE} entries.
					</div>
				)}
			</DialogContent>
		</Dialog>
	);
}

export default MachineHealthLogsModal;
